import * as d3 from "d3";
import { UIUtilIconResources } from "../../util/IconResourses";
import { CardV2 } from "./CardV2";
import { InputFileControl } from "../InputFileControlV2";
import { HTMLTooltipComponent } from "../../controlWC/TooltipComponent";
import { DataUtilLocalStorage } from "../../../data/util/LocalStorage";
import { Router } from "../../../routes/Router";

type TUpdateImageCallback = ((src64: string, file: File) => Promise<boolean>);
interface IImageConfig extends InputFileControl.IConfig {
    UpdateImageCallbackService?: TUpdateImageCallback;
}
interface IItemSeccion {
    ID: string;
    Title?: string;
    GetTemplateContent?: (section: TSelectionHTML<"htmlelement">) => void;
    OnUpdate: (section: TSelectionHTML<"div">) => void;
}

interface IItemInfoGeneral {
    TopicTag?: string;
    Description?: string | ((elemento: TSelectionHTML<"htmlelement">) => void);
}

export class CardInfoV2 extends CardV2 {
    private cardContentInfoPrincipalSelection: TSelectionHTML<"div">;
    private cardContentInfoPrincipalDescripContSelection: TSelectionHTML<"div">;
    private cardContentSeccionesSelection: TSelectionHTML<"div">;
    protected ctrlImage: InputFileControl.InputFile;

    constructor() {
        super();
        this.InitCardInfo();
    }

    private InitCardInfo() {
        this.cardSelection
            .classed("UI_CardInfo", true)
            .classed("collapsed", (() => {
                const savedCollapsedStatus = DataUtilLocalStorage._GetItem(Router._GetCurrentPath(), "cardinfo_collapsed")
                return savedCollapsedStatus == "1"
            })());

        this.cardContentInfoPrincipalSelection = this.cardContentContainerSelection.append("div")
            .classed("resumen_gral", true);

        this.cardContentInfoPrincipalDescripContSelection = this.cardContentInfoPrincipalSelection.append("div")
            .classed("descripcion_gral", true);

        this.cardContentSeccionesSelection = this.cardContentContainerSelection.append("div")
            .classed("secciones", true);

        this.cardContentInfoPrincipalSelection.append("wc-tooltip")
            .attr("class", "tooltip_resumen")
            .attr("position", "right")
            .attr("max-width", "300px")

        this.cardSelection.append("img")
            .attr("class", "btn_collapser")
            .attr("src", UIUtilIconResources.CGeneral.AngleDown)
            .attr("draggable", false)
            .on("click", () => {
                const colapsar = !this.cardSelection.classed("collapsed")
                this.cardSelection.classed("collapsed", colapsar);
                DataUtilLocalStorage._SetItem(Router._GetCurrentPath(), "cardinfo_collapsed", Number(colapsar))
            });

        this.cardSelection.append("img")
            .attr("class", "btn_returninfogral")
            .attr("src", UIUtilIconResources.CGeneral.AngleDown)
            .attr("draggable", false)
            .on("click", () => {
                this.cardContentContainerSelection.node().scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            });
    }

    private timeoutUpdateTooltip: NodeJS.Timeout;
    private UpdateTooltipResumenGral() {
        if (this.timeoutUpdateTooltip) {
            clearTimeout(this.timeoutUpdateTooltip);
            this.timeoutUpdateTooltip = null;
        }
        this.timeoutUpdateTooltip = setTimeout(() => {
            this.timeoutUpdateTooltip = null;
            const tooltip = this.cardContentInfoPrincipalSelection.select<HTMLTooltipComponent>(".tooltip_resumen");
            const isVisible = tooltip.node()?._Visible;

            tooltip.selectAll(":scope>*").remove();

            const tooltipContent: HTMLElement = this.cardContentContainerSelection.node().cloneNode(true) as HTMLElement;
            tooltipContent.querySelector(".resumen_gral>.foto_control_container")?.remove();
            tooltip.node()._SetObservedElementsAdvanced({
                Target: this.cardContentInfoPrincipalSelection.node(),
                HTMLBasic: tooltipContent.outerHTML,
            })

            if (isVisible) {
                setTimeout(() => {
                    tooltip.node()._Visible = true;
                });
            }
        }, 100);
    }

    public _RefeshTooltipResumenGral() {
        if (this["__timeOutTooltip"]) {
            clearTimeout(this["__timeOutToolTip"]);
            this["__timeOutToolTip"] = null;
        }
        this["__timeOutToolTip"] = setTimeout(() => {
            this["__timeOutToolTip"] = null;
            this.UpdateTooltipResumenGral();
        }, 100)
        return this;
    }

    public _MainInfo_CreateImageControl(config: IImageConfig = {}): this {
        this.ctrlImage = new InputFileControl.InputFile({
            ...{
                DefaultBackgroundImage: UIUtilIconResources.CMenuIco.Escuela,
                OnValideBeforeRender: async (isImage, isFromInput, file, src) => {
                    let src64 = src.split(",")[1];
                    if (isImage && isFromInput && config.UpdateImageCallbackService) {
                        return await config.UpdateImageCallbackService(src64, file);
                    }
                    return true;
                },
                OnChange: (isImage, isFromInput, file, src) => {
                    // console.log(src, isImage)
                },
                OnEndLoadFileStatus: (isImage, isFromInput, isSuccesful) => {
                    // console.log(isSuccesful, this.photoIsUpdating, "OnImgEndLoad")
                    // if (isSuccesful && this.photoIsUpdating) {
                    //     this.ControlImage.prop_SpinnerLoadVisible = true;
                    // }
                    // this.photoIsUpdating = false;
                },
                NameTest: "Logo CardInfo",
                Border: {
                    Width: 5,
                    Color: null
                }
            },
            ...config
        });
        this.cardContentInfoPrincipalSelection.node()
            .insertAdjacentElement("afterbegin", this.ctrlImage._ControlNode);
        return this;
    }

    public _MainInfo_SetURLResourceToImageControl(newUrlResourse: string): this {
        if (this.ctrlImage && this.ctrlImage._UrlResource != newUrlResourse) {
            if (newUrlResourse) {
                this.ctrlImage._Reset();
            }
            this.ctrlImage._UrlResource = newUrlResourse;
        }
        return this;
    }

    public _MainInfo_ImageControlDisable(disable: boolean) {
        if (this.ctrlImage) {
            this.ctrlImage._AreaOptionsVisible(!disable)
        }
        return this;
    }

    public _MainInfo_SetColors(spinner: string, border: string) {
        if (this.ctrlImage) {
            this.ctrlImage._SpinnerColor = spinner;
            this.ctrlImage._Border = {
                ...this.ctrlImage._Border,
                Color: border
            }
        }
        return this;
    }

    public _MainInfo_SetDescripcionGeneralPrimaryInfo(text: string): this {
        let lblCabecera = this.cardContentInfoPrincipalDescripContSelection.select<HTMLElement>(":scope > .cabecera");
        if (!lblCabecera.node()) {
            lblCabecera = d3.create("b")
                .attr("class", "cabecera");
            this.cardContentInfoPrincipalDescripContSelection
                .node()
                .insertAdjacentElement("afterbegin", lblCabecera.node());
        }
        lblCabecera.text(text);
        this.UpdateTooltipResumenGral();
        return this;
    }

    public _MainInfo_SetDescripcionGeneralSecondaryInfo(items: IItemInfoGeneral[]): this {
        function UpdateItem(item: TSelectionHTML<"label", IItemInfoGeneral>) {
            return item
                .each((d, i, elements) => {
                    let topicTagElement = elements[i].querySelector("b");
                    let descriptionElement = elements[i].querySelector("span");

                    if (d.TopicTag && !topicTagElement) {
                        topicTagElement = document.createElement("b");
                        elements[i].insertAdjacentElement("afterbegin", topicTagElement);
                    }
                    else if (!d.TopicTag && topicTagElement) {
                        topicTagElement.remove();
                        topicTagElement = null;
                    }
                    if (topicTagElement) {
                        topicTagElement.textContent = d.TopicTag;
                        if (d.Description) {
                            topicTagElement.textContent += ": "
                        }
                    }

                    if (d.Description && !descriptionElement) {
                        descriptionElement = document.createElement("span");
                        elements[i].insertAdjacentElement("beforeend", descriptionElement);
                    }
                    else if (!d.Description && descriptionElement) {
                        descriptionElement.remove();
                        descriptionElement = null;
                    }
                    if (descriptionElement) {
                        descriptionElement.textContent = "";
                        if (typeof (d.Description) === "string") {
                            descriptionElement.textContent = d.Description;
                        } else {
                            d.Description(d3.select(descriptionElement));
                        }
                    }
                });
        }
        this.cardContentInfoPrincipalDescripContSelection
            .selectAll<HTMLLabelElement, IItemInfoGeneral>(":scope > .lbl_info")
            .data(items, (d, i) => i.toString())
            .join(
                enter => UpdateItem(
                    enter.append("label")
                        .attr("class", "lbl_info")
                ),
                update => UpdateItem(update),
                exit => exit.remove()
            )
        this.UpdateTooltipResumenGral();
        return this;
    }

    public _SetSections(secciones: IItemSeccion[]): this {
        this.cardContentSeccionesSelection
            .selectAll<HTMLDivElement, IItemSeccion>(":scope > .item_seccion")
            .data(secciones, d => d.ID)
            .join(
                enter => {
                    const itemEnter = enter.append("div")
                        .attr("class", "item_seccion");
                    itemEnter
                        .append("label")
                        .attr("class", "tittle")
                        .classed("hide", d => (d.Title === undefined))
                    itemEnter
                        .each((d, i, elements) => {
                            const seccion = d3.select(elements[i]);
                            d.GetTemplateContent(seccion);
                            d.OnUpdate(seccion);
                        })
                    return itemEnter;
                },
                update => {
                    update.select<HTMLLabelElement>(":scope > .tittle")
                        .attr("class", "tittle")
                        .classed("hide", d => (d.Title === undefined));
                    update
                        .each((d, i, elements) => {
                            const seccion = d3.select(elements[i]);
                            d.OnUpdate(seccion);
                        })
                    return update;
                },
                exit => exit.remove(),
            );
        //setTimeout(this.UpdateTooltipResumenGral.bind(this), 200);
        this.UpdateTooltipResumenGral();
        return this;
    }

    public _SetTitulo(titulo: (string | null)) {
        super._SetTitulo(titulo)
            .cardHeaderSelection
            .classed("hide", !titulo);
        return this;
    }
}
